import { render, staticRenderFns } from "./externalaccess.vue?vue&type=template&id=7d4f4bd2"
import script from "./externalaccess.vue?vue&type=script&lang=js"
export * from "./externalaccess.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports